export const schemaEvents = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description', 'link', 'keywords', 'audience', 'limit'],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      description: {
        title: 'Description',
        widget: 'textarea',
      },
      link: {
        title: 'Button URL',
        widget: 'object_browser',
        mode: 'link',
        allowExternals: false,
      },
      keywords: {
        title: 'Keywords',
        type: 'array',
        widget: 'array',
        items: {
          vocabulary: { '@id': 'plone.app.vocabularies.Keywords' },
        },
      },
      audience: {
        title: 'Audience',
        description: 'Add audience to categorize your events',
        widget: 'token',
        vocabulary: {
          '@id': '/@vocabularies/unite.audience',
        },
      },
      limit: {
        title: 'Limit',
        widget: 'integer',
      },
    },
  };
};

export default schemaEvents;
